import { createAction } from '@reduxjs/toolkit';

export interface IModalShowToastPayload {
  payload: {
    text: string,
    ms: number,
  },
}

export const showToast = createAction('TOAST/SHOW', (text, ms = 1000): IModalShowToastPayload => ({
  payload: {
    text,
    ms,
  },
}));

export interface IModalOpenToastPayload {
  payload: {
    isOpen: boolean,
  },
}

export const setOpenToast = createAction('TOAST/SET_OPEN', (isOpen = true): IModalOpenToastPayload => ({
  payload: {
    isOpen,
  },
}));
